import React, { useLayoutEffect } from 'react';
import { CommitteeDocumentsGrid } from '../../components';
import { useGlobalState } from '../../contexts/global-state';
import { usePageTitle } from '../../contexts/page-title';

export default function ({ committeeId }) {
  const { committees } = useGlobalState();
  const { setTitle } = usePageTitle();

  const committee = committees?.find((c) => String(c.committeeId) === String(committeeId));
  const committeeName = committee?.committeeName ?? 'Committee';

  useLayoutEffect(() => setTitle(`${committeeName} - Documents`), [setTitle, committeeName]);

  return (
    <div className="responsive-paddings">
      <CommitteeDocumentsGrid committeeId={committeeId} />
    </div>
  );
}
